import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/styles/tailwind.css'
import './assets/styles/config.css'

Vue.use(ElementUI);

import md5 from 'js-md5';

Vue.prototype.$md5 = md5
import router from './router'

import store from "./store"

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
